export const formatUSD = (value: number): string =>
	value.toLocaleString("en-US", {
		currency: "USD",
		style: "currency"
	});
